import {Injectable, InjectionToken, Injector} from "@angular/core";
import {ComponentType} from "@angular/cdk/overlay";
import {BehaviorSubject, Observable} from "rxjs";
import {map} from "rxjs/operators";
import {ComponentPortal} from "@angular/cdk/portal";
import {SideSheetRef} from "@app/presentation/services/side-sheet/side-sheet-ref";
import {Router} from "@angular/router";


export const SIDE_SHEET_DATA = new InjectionToken<any>('SideSheetData');

export interface SideSheetConfig {
    data?: unknown;
}

@Injectable({
    providedIn: 'root'
})
export class SideSheetService<T = any> {
    
    private componentPortalHistory: Array<ComponentPortal<T>> = []

    private currentComponentPortalSubject= new BehaviorSubject<ComponentPortal<T> | null>(null);
    readonly currentComponentPortal$: Observable<ComponentPortal<T> | null> = this.currentComponentPortalSubject.asObservable();

    readonly isSideSheetOpen$ = this.currentComponentPortal$.pipe(map(component => component != null));

    constructor(
        private router: Router,
    ) {

    }

    open(component: ComponentType<T>, config?: SideSheetConfig ): SideSheetRef {
        const injector = Injector.create({
            providers: [
                {
                    provide: SideSheetRef,
                    useFactory: (sideSheetService: SideSheetService, router: Router) => {

                        return new SideSheetRef(sideSheetService, router)
                    },
                    deps: [SideSheetService, Router]
                },
                {
                    provide: SideSheetService,
                    useValue: this,
                },
                {
                    provide: Router,
                    useValue: this.router
                },
                {
                    provide: SIDE_SHEET_DATA,
                    useValue: config?.data,
                }
            ]
        })
        const portal = new ComponentPortal(component, undefined, injector);
        this.componentPortalHistory.push(portal);
        this.currentComponentPortalSubject.next(portal);
        return injector.get(SideSheetRef);
    }

    back() {
        this.componentPortalHistory.pop();
        const previousComponentPortal = this.componentPortalHistory[this.componentPortalHistory.length - 1]
        this.currentComponentPortalSubject.next(previousComponentPortal ?? null);
    }

    close() {
        this.componentPortalHistory = [];
        this.currentComponentPortalSubject.next(null);
    }
}
